var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { DateConverter, dateToISO8601 } from '../../Converter';
import { JsonObject, JsonProperty } from 'json2typescript';
export var MeasurementGroupGranularity;
(function (MeasurementGroupGranularity) {
    MeasurementGroupGranularity["Monthly"] = "P31D";
    MeasurementGroupGranularity["Hourly"] = "PT1H";
})(MeasurementGroupGranularity || (MeasurementGroupGranularity = {}));
var DataPoint = (function () {
    function DataPoint(partial) {
        this.timestamp = new Date();
        this.value = 0;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('timestamp'),
        __metadata("design:type", Date)
    ], DataPoint.prototype, "timestamp", void 0);
    __decorate([
        JsonProperty('value'),
        __metadata("design:type", Object)
    ], DataPoint.prototype, "value", void 0);
    DataPoint = __decorate([
        JsonObject('DataPoint'),
        __metadata("design:paramtypes", [Object])
    ], DataPoint);
    return DataPoint;
}());
export { DataPoint };
export var MeasurementName;
(function (MeasurementName) {
    MeasurementName["ComputeTime"] = "compute_time";
    MeasurementName["DataOut"] = "data_out";
    MeasurementName["RequestCount"] = "request_count";
    MeasurementName["SyncTime"] = "sync_time";
})(MeasurementName || (MeasurementName = {}));
export var MeasurementUnit;
(function (MeasurementUnit) {
    MeasurementUnit["None"] = "";
    MeasurementUnit["Gigabytes"] = "GIGABYTES";
    MeasurementUnit["GigabyteSeconds"] = "GIGABYTE_SECONDS";
    MeasurementUnit["Hours"] = "HOURS";
})(MeasurementUnit || (MeasurementUnit = {}));
var Measurement = (function () {
    function Measurement(partial) {
        this.name = MeasurementName.DataOut;
        this.units = MeasurementUnit.None;
        this.dataPoints = [];
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('name'),
        __metadata("design:type", String)
    ], Measurement.prototype, "name", void 0);
    __decorate([
        JsonProperty('units'),
        __metadata("design:type", String)
    ], Measurement.prototype, "units", void 0);
    __decorate([
        JsonProperty('data_points', [DataPoint]),
        __metadata("design:type", Array)
    ], Measurement.prototype, "dataPoints", void 0);
    Measurement = __decorate([
        JsonObject('Measurement'),
        __metadata("design:paramtypes", [Object])
    ], Measurement);
    return Measurement;
}());
export { Measurement };
var AppMeasurementGroup = (function () {
    function AppMeasurementGroup(partial) {
        this.appName = '';
        this.groupId = '';
        this.appId = '';
        this.start = new Date();
        this.end = new Date();
        this.granularity = MeasurementGroupGranularity.Monthly;
        this.measurements = [];
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('app_name'),
        __metadata("design:type", Object)
    ], AppMeasurementGroup.prototype, "appName", void 0);
    __decorate([
        JsonProperty('group_id'),
        __metadata("design:type", Object)
    ], AppMeasurementGroup.prototype, "groupId", void 0);
    __decorate([
        JsonProperty('app_id'),
        __metadata("design:type", Object)
    ], AppMeasurementGroup.prototype, "appId", void 0);
    __decorate([
        JsonProperty('start', DateConverter),
        __metadata("design:type", Date)
    ], AppMeasurementGroup.prototype, "start", void 0);
    __decorate([
        JsonProperty('end', DateConverter),
        __metadata("design:type", Date)
    ], AppMeasurementGroup.prototype, "end", void 0);
    __decorate([
        JsonProperty('granularity'),
        __metadata("design:type", String)
    ], AppMeasurementGroup.prototype, "granularity", void 0);
    __decorate([
        JsonProperty('measurements', [Measurement]),
        __metadata("design:type", Array)
    ], AppMeasurementGroup.prototype, "measurements", void 0);
    AppMeasurementGroup = __decorate([
        JsonObject('AppMeasurementGroup'),
        __metadata("design:paramtypes", [Object])
    ], AppMeasurementGroup);
    return AppMeasurementGroup;
}());
export { AppMeasurementGroup };
var GroupMeasurementGroup = (function () {
    function GroupMeasurementGroup(partial) {
        this.groupId = '';
        this.start = new Date();
        this.end = new Date();
        this.granularity = MeasurementGroupGranularity.Monthly;
        this.measurements = [];
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('group_id'),
        __metadata("design:type", Object)
    ], GroupMeasurementGroup.prototype, "groupId", void 0);
    __decorate([
        JsonProperty('start', DateConverter),
        __metadata("design:type", Date)
    ], GroupMeasurementGroup.prototype, "start", void 0);
    __decorate([
        JsonProperty('end', DateConverter),
        __metadata("design:type", Date)
    ], GroupMeasurementGroup.prototype, "end", void 0);
    __decorate([
        JsonProperty('granularity'),
        __metadata("design:type", String)
    ], GroupMeasurementGroup.prototype, "granularity", void 0);
    __decorate([
        JsonProperty('measurements', [Measurement]),
        __metadata("design:type", Array)
    ], GroupMeasurementGroup.prototype, "measurements", void 0);
    GroupMeasurementGroup = __decorate([
        JsonObject('GroupMeasurementGroup'),
        __metadata("design:paramtypes", [Object])
    ], GroupMeasurementGroup);
    return GroupMeasurementGroup;
}());
export { GroupMeasurementGroup };
export function getMeasurementFilter(request) {
    if (!request) {
        return undefined;
    }
    var filter = {};
    if (request.start) {
        filter.start = dateToISO8601(request.start);
    }
    if (request.end) {
        filter.end = dateToISO8601(request.end);
    }
    if (request.granularity) {
        filter.granularity = request.granularity;
    }
    return filter;
}
//# sourceMappingURL=Measurement.js.map